export const PAYLOAD_DATA_SCHEMA = 'iglu:com.snowplowanalytics.snowplow/payload_data/jsonschema/1-0-4';



// WEBPACK FOOTER //
// ../src/schemata.ts